$(window).bind("load", function() {
	if ($(window).width() < 481) {
      
      if ($('body').scrollTop() > ($("#buenfin").offset().top) || $('html').scrollTop() > ($("#buenfin").offset().top)) {
                
      }else{
        $('html, body').animate({
                    scrollTop: $("#buenfin").offset().top -60// EL ESTANDAR ES +20
                }, 2000);
      }
    }
}); 